export const AUTH_STARTED = "AUTH_STARTED";
export const AUTH_FAILED = "AUTH_FAILED";
export const AUTH_SUCCEEDED = "AUTH_SUCCEEDED";
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const SET_USER_BLOCKED = "SET_USER_BLOCKED";
export const SET_USER_EXPIRED = "SET_USER_EXPIRED";
export const SET_REPEATED_PASSWORD= "SET_REPEATED_PASSWORD";
export const SET_FORCE_PASSWORD_CHANGE= "SET_FORCE_PASSWORD_CHANGE";
export const FORCE_PASSWORD_CHANGE_FAILED_MESSAGE = "FORCE_PASSWORD_CHANGE_FAILED_MESSAGE";

export const ASSIGN_USERNAME = "ASSIGN_USERNAME";
export const REQUEST_LOADER = "REQUEST_LOADER";
export const OPEN_SNACKBAR = "OPEN_SNACKBAR";
export const CLOSE_SNACKBAR = "CLOSE_SNACKBAR";
export const SET_COOKIES_ACCEPTED = "SET_COOKIES_ACCEPTED";
export const SET_RODO_ACCEPTED = "SET_RODO_ACCEPTED";
export const CHANGE_THEME = "CHANGE_THEME";
export const CHANGE_DRAWER = "CHANGE_DRAWER";
export const ClOSE_DRAWER = "ClOSE_DRAWER";
export const CLOSE_WELCOME_DIALOG = "CLOSE_WELCOME_DIALOG";
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const SET_NOTIFICATION_READ = "SET_NOTIFICATION_READ";
export const SET_OPEN_CONFIRMED_FORCED_PASSWORD_DIALOG = "SET_OPEN_CONFIRMED_FORCED_PASSWORD_DIALOG";

//dashboard types
export const GET_DISTANCE = "GET_DISTANCE";
export const GET_FUEL_USAGE = "GET_FUEL_USAGE";
export const GET_ECO_ROUTES = "GET_ECO_ROUTES";
export const GET_TOTAL_DRIVE_TIME = "GET_TOTAL_DRIVE_TIME";
export const GET_PRIVATE_DRIVE_TIME = "GET_PRIVATE_DRIVE_TIME";
export const GET_CARS_IN_SERVICE = "GET_CARS_IN_SERVICE";
export const GET_ECO_GRADE = "GET_ECO_GRADE";
export const GET_ECO_CARS = "GET_ECO_CARS";
export const GET_ECO_DRIVERS = "GET_ECO_DRIVERS";
export const GET_ALERTS = "GET_ALERTS";
export const GET_TOP_TROPHY_LIST = "GET_TOP_TROPHY_LIST";

//map types
//filter types
export const CHANGE_START_DATE = "CHANGE_START_DATE";
export const CHANGE_END_DATE = "CHANGE_END_DATE";
export const CHANGE_GROUP_FILTER = "CHANGE_GROUP_FILTER";
export const CHANGE_BRAND_FILTER = "CHANGE_BRAND_FILTER";
export const CHANGE_MODEL_FILTER = "CHANGE_MODEL_FILTER";
export const CHANGE_FUEL_TYPE_FILTER = "CHANGE_FUEL_TYPE_FILTER";
export const CHANGE_GEARBOX_FILTER = "CHANGE_GEARBOX_FILTER";
export const CHANGE_GPRS_FILTER = "CHANGE_GPRS_FILTER";
export const CHANGE_DRIVE_FILTER = "CHANGE_DRIVE_FILTER";
export const CHANGE_REFUEL_FILTER = "CHANGE_REFUEL_FILTER";
export const CHANGE_REGION_FILTER = "CHANGE_REGION_FILTER";
export const CHANGE_WARNINGS_FILTER = "CHANGE_WARNINGS_FILTER";
export const CHANGE_INSERVICE_FILTER = "CHANGE_INSERVICE_FILTER";
export const CHANGE_SHOW_ARCHIVED_FILTER = "CHANGE_SHOW_ARCHIVED_FILTER";
export const CHANGE_SHOW_NOT_ARCHIVED_FILTER = "CHANGE_SHOW_NOT_ARCHIVED_FILTER";
export const CHANGE_FILTERS_DEFAULT = "CHANGE_FILTERS_DEFAULT";
export const SET_DRIVE_FILTER = "SET_DRIVE_FILTER";
export const SET_SEARCH_FIELD = "SET_SEARCH_FIELD";
export const SET_GROUPS_FILTER = "SET_GROUPS_FILTER";
export const SET_BRANDS_FILTER = "SET_BRANDS_FILTER";
export const SET_ALL_MODELS_FILTER = "SET_ALL_MODELS_FILTER";
export const SET_MODELS_FILTER = "SET_MODELS_FILTER";
export const SET_FUELTYPES_FILTER = "SET_FUELTYPES_FILTER";
export const SET_GEARBOXES_FILTER = "SET_GEARBOXES_FILTER";
export const SHOW_ARCHIVED_FILTER = "SHOW_ARCHIVED_FILTER";
export const SHOW_INSERVICE_FILTER = "SHOW_INSERVICE_FILTER";
export const SHOW_POI_ON_MAP_FILTER = "SHOW_POI_FILTER";
export const SET_ADDRESS_STREET = "SET_ADDRESS_STREET";
export const SET_ADDRESS_CITY = "SET_ADDRESS_CITY";
export const SET_ADDRESS_POSTAL_CODE = "SET_ADDRESS_POSTAL_CODE";
export const SET_ADDRESS_RADIUS = "SET_ADDRESS_RADIUS";

//request types
export const GET_CAR = "GET_CARS";

//map cars
export const SET_SELECTED_CAR = "SET_SELECTED_CAR";
export const SET_MAP_CARS = "SET_MAP_CARS";
export const CLEAR_ALL_SELECTED = "CLEAR_ALL_SELECTED";
export const TRACK_ALL_CARS = "TRACK_ALL_CARS";

//map routes
export const SET_MAP_ROUTES = "SET_MAP_ROUTES";
export const SET_SELECTED_ROUTES = "SET_SELECTED_ROUTES";
export const UPDATE_START_ADDRESS = "UPDATE_START_ADDRESS";
export const UPDATE_END_ADDRESS = "UPDATE_END_ADDRESS";
export const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE";
export const CHANGE_SHOW_CURRENT_ROUTE = "CHANGE_SHOW_CURRENT_ROUTE";

//map
export const MAP_FIT_BOUNDS = "MAP_FIT_BOUNDS";
export const MAP_FIT_ANY_BOUNDS = "MAP_FIT_ANY_BOUDS";
export const MARK_ROUTE_AS_SELECTED = "MARK_ROUTE_AS_SELECTED";
export const MAP_MANUALLY_MOVED_OR_ZOOMED = "MAP_MANUALLY_MOVED_OR_ZOOMED";

//cars
export const SET_CARS = "SET_CARS";
export const SET_CAR = "SET_CAR";
export const SET_ZONES = "SET_ZONES";
export const SET_INDIVIDUAL_WORKING_HOURS = "SET_INDIVIDUAL_WORKING_HOURS";
export const SET_INSURANCE_DATE = "SET_INSURANCE_DATE";
export const SET_TECHNICAL_INSPECTIONS = "SET_TECHNICAL_INSPECTIONS";
export const SET_SERVICE_INSPECTIONS = "SET_SERVICE_INSPECTIONS";
export const SET_SERVICE_INSPECTIONS_HISTORY = "SET_SERVICE_INSPECTIONS_HISTORY";
export const SET_REPORTS_AND_NOTIFICATIONS = "SET_REPORTS_AND_NOTIFICATIONS";
export const SET_CONTRACTED_MILEAGE = "SET_CONTRACTED_MILEAGE";
export const SET_DATA = "SET_DATA";
export const SET_CAR_SETTINGS = "SET_CAR_SETTINGS";
export const SET_SMS = "SET_SMS";
export const SET_CAR_PARAMETERS = "SET_CAR_PARAMETERS";
export const SET_CAR_EVIDENCE = "SET_CAR_EVIDENCE";
export const SET_CAR_ECO_CHART = "SET_CAR_ECO_CHART";
export const SET_POSSIBLE_PARAMETERS = "SET_POSSIBLE_PARAMETERS";
export const SET_CAR_POOL = "SET_CAR_POOL";
export const SET_CAR_RENT = "SET_CAR_RENT";
export const SET_CHANGES = "SET_CHANGES";
export const SET_REMARKS = "SET_REMARKS";
export const SET_CAR_DAMAGE = "SET_CAR_DAMAGE";
export const SET_CAR_DAMAGE_IMAGE = "SET_CAR_DAMAGE_IMAGE";
export const DELETE_CAR_DAMAGE_IMAGE = "DELETE_CAR_DAMAGE_IMAGE";
export const SET_CAR_PRICING = "SET_CAR_PRICING";

//rent list
export const SET_RENT = "SET_RENT";
export const SET_RENT_LIST = "SET_RENT_LIST";
export const SET_CLIENTS = "SET_CLIENTS";
export const SET_CLIENT = "SET_CLIENT";

//groups view
export const SET_GROUPS = "SET_GROUPS";
export const ADD_GROUP = "ADD_GROUP";
export const SET_GROUP_CARS = "SET_GROUP_CARS";
export const SET_AVAILABLE_GROUP_CARS = "SET_AVAILABLE_GROUP_CARS";

//reports view
export const SET_REPORTS = "SET_REPORTS";
export const SELECT_REPORT = "SELECT_REPORT";
export const SET_KEYWORDS_LIST = "SET_KEYWORDS_LIST";
export const SET_PENDING_LIST = "SET_PENDING_LIST";
export const SET_AUTOMATIC_REPORT_LIST = "SET_AUTOMATIC_REPORT_LIST";
export const SET_FILE_ID = "SET_FILE_ID";

//drivers
export const SET_ALL_DRIVERS = "SET_ALL_DRIVERS";
export const DELETE_DRIVER = "DELETE_DRIVER";
export const ADD_DRIVER = "ADD_DRIVER";
export const UPDATE_DRIVER = "UPDATE_DRIVER";
export const SET_DRIVER_ECO_CHART = "SET_DRIVER_ECO_CHART";
export const SET_DRIVER_MOBILE_APP_KEY = "SET_DRIVER_MOBILE_APP_KEY";

//users
export const SET_USERS_LIST = "SET_USERS_LIST";
export const ADD_USER = "ADD_USER";
export const DELETE_USER = "DELETE_USER";
export const SET_USER_CARS = "SET_USER_CARS";
export const UPDATE_USER = "UPDATE_USER";

//settings
export const SET_DEFAULT_EMAILS_AND_PHONES = "SET_DEFAULT_EMAILS_AND_PHONES";
export const SET_SETTINGS_NOTIFICATIONS = "SET_SETTINGS_NOTIFICATIONS";
export const SET_SETTINGS_REMINDERS = "SET_SETTINGS_REMINDERS";
export const SET_OTHER_SETTINGS = "SET_OTHER_SETTINGS";
export const SET_SETTINGS_MOBILE_APP_KEY = "SET_SETTINGS_MOBILE_APP_KEY";
export const SET_SETTINGS_TIRES_CHANGE = "SET_SETTINGS_TIRES_CHANGE";
export const SET_SETTINGS_REGULAR_HOLIDAYS = "SET_SETTINGS_REGULAR_HOLIDAYS";
export const SET_SETTINGS_MOVING_HOLIDAYS = "SET_SETTINGS_MOVING_HOLIDAYS";
export const SET_SETTINGS_DAYS_OFF = "SET_SETTINGS_DAYS_OFF";
export const SET_SETTINGS_WORKING_HOURS = "SET_SETTINGS_WORKING_HOURS";
export const SET_SETTINGS_POI_POINTS = "SET_SETTINGS_POI_POINTS";
export const SET_SETTINGS_POI_COORDS = "SET_SETTINGS_POI_COORDS";
export const SET_SETTINGS_TROPHY = "SET_SETTINGS_TROPHY";
export const CHANGE_SAVE_READINESS = "CHANGE_SAVE_READINESS";
export const CHANGE_SAVE_SETTINGS = "CHANGE_SAVE_SETTINGS";
export const UPDATE_POI = "UPDATE_POI";

//rent
export const SET_RENT_SETTINGS = "SET_RENT_SETTINGS";
export const SET_RENT_CLIENTS = "SET_RENT_CLIENTS";
export const UPDATE_RENT_CLIENT ="UPDATE_RENT_CLIENT";
export const SET_RENT_PRICING = "SET_RENT_PRICING";
export const UPDATE_RENT_PRICING ="UPDATE_RENT_PRICING";
export const SET_RENT_OPERATORS = "SET_RENT_OPERATORS";
export const UPDATE_RENT_OPERATORS ="UPDATE_RENT_OPERATORS";
